import { getPublicClientsApi, postPublicClientsApi } from "@Shared/@Utils/ajax";
export const getDocumentSignedURL = (token, code, {
  fileName
}) => {
  const endpoint = "/clients/application/noa/document";
  return getPublicClientsApi({
    fileName,
    code
  }, token, endpoint);
};
export const markDocumentAsUploaded = (token, code, {
  documentIds,
  issue
}) => {
  const endpoint = "/clients/application/noa/document";
  return postPublicClientsApi({
    documentIds,
    issue: issue || null,
    code
  }, token, endpoint);
};
export const markRequestAsCompleted = (token, code, {
  status,
  issue
}) => {
  const endpoint = "/clients/application/noa/complete";
  return postPublicClientsApi({
    status,
    issue: issue || null,
    code
  }, token, endpoint);
};
export const validateToken = (token, code) => {
  const endpoint = "/clients/application/noa/validate";
  return postPublicClientsApi({
    code
  }, token, endpoint);
};